<ng-container *ngIf="productMenu$ | async as productMenu">
	<site-navigation_top
		test-id="topNavigation"
		[tabs]="productMenu"
		[activeTabKey]="activeTabKey"
		(tabClick)="onTabClicked($event)"
	>
	</site-navigation_top>
</ng-container>
